<template>
  <div class="page final extrainfo">
    <main>
      <div class="citybg"></div>

      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final">Complément <br/>d'information</h2>
          <p class="bodyslide--final">
            <!--Hieronder kan je heel wat extra informatie vinden die je op weg
            helpt in je levensweg.-->
          </p>
        </div>
        <div class="babylyingcontainer lessspace">
          <img
            src="./../assets/img/introbeeld.svg"
            class="introbeeld hidden-sm visible-md"
          />
        </div>
      </header>
      <section class="infosection inhoudstabel" >
        <p class="articlebody">
          
        <ul class="opsomminginhoud">
          <li>
             <router-link to="/extrainfo#eicelleninvriezen" @click.native="goto('eicelleninvriezen')" >Congeler des ovocytes ? Peut-être.</router-link>
          </li>
          <li>
           <router-link to="/extrainfo#houdbaarheidsdatum" @click.native="goto('houdbaarheidsdatum')" >Les ovocytes et les spermatozoïdes ont une date de péremption.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#nietzeker" @click.native="goto('nietzeker')" >Je ne suis pas certain(e) de vouloir des enfants.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#willenkind" @click.native="goto('willenkind')" >Nous aimerions avoir un enfant bientôt.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#luktnietmeteen" @click.native="goto('luktnietmeteen')" >Nous essayons d’avoir un enfant, mais cela ne fonctionne pas tout de suite.</router-link>
          </li>
          <li>
            <router-link to="/extrainfo#vruchtbaarheidbeschermen" @click.native="goto('vruchtbaarheidbeschermen')" >Que puis-je faire pour protéger ma fertilité ?</router-link>
          </li>

        </ul>
        </p>
      </section>

      <section ref="eicelleninvriezen" class="infosection" id="eicelleninvriezen">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Congeler des ovocytes ? Peut-être.</h3>
            <p class="sectionintro">
              Un nombre croissant de couples éprouvent aujourd’hui des difficultés à fonder une famille de la taille qu'ils souhaitent. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  Peut-être as-tu toujours rêvé d’une famille nombreuse, mais le partenaire idéal avec lequel tu veux fonder une famille ne s’est pas encore présenté ? Ou tu ne te sens pas vraiment prête ? Peut-être pourrais-tu envisager la congélation d’ovocytes ? Il peut s’agir d’une solution pour certaines femmes, même si c’est une <strong>procédure onéreuse</strong> (1500 € à 3000 € par cycle) et <strong>que les chances de grossesse</strong> sont modérées (30 à 40 % de chances de réussite si 10 ovocytes sont disponibles). Il est important de congeler tes ovocytes <strong>avant les 35 ans</strong> pour maximiser les chances de grossesse. Plus tu es jeune lors de cette procédure (et donc plus tes ovocytes sont jeunes), plus tu as de chances de succès.
                </p>
              </article>
          </div>
        </div>
      </section>
       <section ref="houdbaarheidsdatum" class="infosection" id="houdbaarheidsdatum">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Les ovocytes et les spermatozoïdes ont une date de péremption</h3>
            <p class="sectionintro">
              Savais-tu que 25 ans est l’âge biologique le plus approprié pour une femme pour concevoir un enfant ? À 30 ans, la fertilité chez les femmes a déjà considérablement diminué. C’est pourtant l’âge auquel la plupart des femmes conçoivent leur premier enfant en Belgique. 
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
               <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  Contrairement aux hommes, aucune nouvelle cellule reproductrice n’est produite pendant la vie d’une femme. À la naissance, il y a donc <strong>un nombre maximal d’ovocytes</strong> et ceux-ci diminuent de manière croissante au fil des ans. À 40 ans, le nombre d’ovocytes a déjà fortement baissé (plus de 90 %) et leur <strong>qualité</strong> diminue également. De ce fait, il est plus difficile de tomber enceinte à cet âge-là et les mères plus âgées courent un <strong>risque accru</strong> de fausse couche ou de mettre au monde un enfant atteint de trisomie 21 (ou d’autres anomalies).  
                  <br/><br/>
                  De nombreuses femmes demandent un dosage sanguin de l’AMH. Ce test permet de détecter l’hormone anti-müllerienne dans le sang, dont la valeur donnerait une indication sur la réserve ovarienne qu’une femme possède encore. Les valeurs sont toutefois très variables et dépendent notamment du moment auquel tu effectues le test. Il se peut que le résultat d'un tel test t’inquiète inutilement ou qu'il tu fasses au contraire reporter de quelques années encore le désir d'enfant alors que l'âge est précisément un facteur déterminant bien plus important pour ta fertilité. Un tel test n’est donc pas très utile sans qu’il soit interprété lors d’une consultation dédiée.
                  <br/><br/>
                  Les hommes produisent quant à eux de nouvelles cellules reproductrices et peuvent avoir des enfants jusqu’à un âge plus avancé, à condition que leur partenaire soit plus jeune. L'âge de la partenaire de l'homme sera donc un important facteur déterminant pour pouvoir avoir des enfants. Un certain nombre de nouvelles études ont toutefois aussi observé un effet de <strong>l’âge de l’homme</strong> sur la qualité des spermatozoïdes. Il peut par exemple s’écouler plus de temps avant une grossesse et il existe un risque accru de fausse couche si le père est plus âgé.  
                  <br/><br/>
                  Bien que la <strong>procréation médicalement assistée</strong> (comme la fécondation in vitro ) puisse aider un très grand nombre de couples qui ont des problèmes de fertilité, cette technique <strong>n’est pas efficace à 100 %</strong>. Ici aussi, l’âge de la femme est un important facteur déterminant pour une grossesse. Les femmes de moins de 35 ans ont environ 30 % de chances de grossesse lors de la première tentative. À l’âge de 40 ans, ce pourcentage n’est plus que de 10 %. Les chances de grossesse après <strong>l’âge</strong> de 45 ans sont presque nulles.  
                </p>
               
              </article>
          </div>
        </div>
      </section>

       <section ref="nietzeker" class="infosection" id="nietzeker">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Je ne suis pas certain.e de vouloir des enfants.</h3>
            <p class="sectionintro">
              Certaines personnes ont une vision très claire de l’avenir, d’autres préfèrent vivre au jour le jour. Tout le monde ne sait pas avec certitude dans quelle mesure avoir des enfants fait partie ou non de « l’avenir idéal ».  
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  S’il ne faut pas absolument concevoir ton avenir en détail, essaye de réfléchir (éventuellement avec ton partenaire) à <strong>ce qui est important pour toi</strong> dans la vie. Des enfants en font-ils partie ? Quel est ton avis sur les enfants ? Que veut ton partenaire selon toi ?<br/>
Pourquoi veux-tu des enfants ou pourquoi n’en veux-tu pas ? Qu’est-ce qui te fait douter ? Que te faut-il pour pouvoir prendre une décision ? Quels sont <strong>tes doutes</strong> sur ce que tu juges important ? Comment vois-tu ta vie avec ou sans enfants ? Comment te vois-tu en tant que parent ? Que se passerait-il si toi ou ta partenaire étiez enceinte ? Qu’est-ce que cela signifierait pour toi ? Comment éviter une grossesse non planifiée tant que tu ne veux pas (encore) d’enfants ?
<br/><br/>Une étude démontre qu’un couple moyen sans enfant est <strong>plus heureux</strong> qu’un couple avec enfants. Surtout s’il s’agit d’un choix délibéré. C'est certainement un point sur lequel il faut se pencher en cas de doute.
<br/><br/>Envie d’<strong>optimiser</strong> les chances de pouvoir avoir des enfants plus tard ? Essayez dès maintenant ce qui suit :
<ul class="opsomming"><li>Protège-toi des maladies sexuellement transmissibles</li><li>N’attend pas trop longtemps. La fertilité des femmes commence à diminuer après 30 ans. La fertilité d’une femme de 35 ans est deux fois moins élevée que celle d’une femme de 25 ans.</li></ul>

                </p>
              </article>
          </div>
        </div>
      </section>
      <section ref="willenkind" class="infosection" id="willenkind">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Nous aimerions avoir un enfant bientôt.</h3>
            
          </header>
            <div class="articleblocks">
              <article >
                <p class="articlebody">
                  Tu trouveras des conseils pour une grossesse saine sur les sites web suivants :
                  <ul class="opsomming">
                    <!--li>
                      <a target="_blank" href="https://www.gezondzwangerworden.be">www.gezondzwangerworden.be</a>
                    </li-->
                    <li>
                      <a target="_blank" href="https://www.one.be">www.one.be</a>
                    </li>
                  </ul>
                  Outre l’âge, un <strong>mode de vie sain</strong> et un <strong>poids sain</strong> sont importants pour les deux partenaires afin d’augmenter les chances de grossesse et optimiser la santé du bébé. Tu trouveras de plus amples informations sur l’impact du mode de vie sur la fertilité ici:
                   <ul class="opsomming">
                    <!--li>
                      <a target="_blank" href="https://www.one.be/public/envie-dun-bebe/sante/visite-préconceptionnelle/">Visite préconceptionnelle.</a>
                    </li-->
                    <li>
                      <a target="_blank" href="https://www.one.be/public/envie-dun-bebe/consultation-peps/des-questions-sur-la-conception/">Des questions sur la conception.</a>
                    </li>
                    <li>
                      <a target="_blank" href="https://www.one.be/public/videodetail/youtube/air-de-familles-grossesse-la-visite-préconceptionnelle/">Vidéos informatives - Air de famille -: la visite préconceptionnelle.</a>
                    </li>
                    </ul>
                </p>
              </article>
          </div>
        </div>
      </section>
      <section ref="luktnietmeteen" class="infosection" id="luktnietmeteen">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Nous essayons d’avoir un enfant, mais cela ne fonctionne pas tout de suite.</h3>
            <p class="sectionintro">
              La plupart du temps, on ne sait pas combien de temps il a fallu à d’autres personnes pour concevoir un enfant. Tout le monde n’y arrive certainement pas le premier mois.  
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
               
                </h4>
                <p class="articlebody">
                  Tu as moins de 35 ans ? Dans ce cas, tu peux attendre une petite année avant de chercher de l’aide. Si tu as plus de 35 ans, il y a moins de temps à perdre et après 6 mois, tu peux déjà consulter <strong>un médecin</strong> pour ton désir d'enfant.<br/><br/>
                  La partenaire féminine n'a pas ses règles (environ) tous les mois ? Alors, mieux vaut prendre rendez-vous immédiatement avec un médecin. 
Il peut être difficile de vouloir un enfant, et que cela ne fonctionne pas tout de suite. <strong>L’attente d’un enfant</strong> et les traitements de fertilité peuvent générer beaucoup de stress et de pression sur ta relation de couple. Discutes-en aussi avec ton médecin. De nombreuses personnes consultent un psychologue lorsqu’elles sont confrontées à un désir d’enfant non satisfait.
<!--br/><br/>De informatie op deze sites kunnen jou mogelijk interesseren: <ul class="opsomming">
  <li>
    <a target="_blank" href="https://www.kindengezin.be/kinderwens/vruchtbaarheid/">https://www.kindengezin.be</a>
  </li>
  <li>
    <a target="_blank" href="https://www.deverdwaaldeooievaar.be/medische-begeleiding/medische-begeleiding/fertiliteitscentra-binnenland">https://www.deverdwaaldeooievaar.be</a>
  </li>
</ul-->
<br/><br/>
Tu as <strong>une relation homosexuelle</strong> ? Discute de ton éventuel désir d’enfant avec ton médecin traitant ou un médecin dans un centre de procréation médicalement assisté. <br/><br/>Si tu envisages <strong>l'adoption ou l’accueil familial</strong>, tu trouveras ici de plus amples informations :
<ul class="opsomming">
  <li><a target="_blank" href="https://www.one.be/public/1-3-ans/adoption/le-service-one-adoption/
">Le service one adoption
</a></li>
</ul>



                </p>
              </article>
          </div>
        </div>
      </section>

      <section ref="vruchtbaarheidbeschermen" class="infosection" id="vruchtbaarheidbeschermen">
        <div class="leftblok">
           <header>
            <h3 class="sectiontitle">Que puis-je faire pour protéger ma fertilité ?</h3>
            <p class="sectionintro">
              Il est clair qu’il est très important de ne pas attendre trop longtemps pour avoir des enfants afin d’augmenter les chances de grossesse.  
            </p>
          </header>
            <div class="articleblocks">
              <article class="specialcols">
                <h4 class="articletitle">
                </h4>
                <p class="articlebody">
                  C'est surtout important pour les femmes, mais chez les hommes aussi, la qualité du sperme diminue avec l'âge. 
<br/><br/>Par ailleurs, même si c’est cliché, <strong>une vie saine</strong> favorise également ta fertilité. Il a été démontré que le tabagisme, la consommation d’alcool, le surpoids, etc. ont un effet négatif sur la fertilité (y compris chez les hommes).    

<br/><br/>Savais-tu que l'exposition à des substances environnementales nocives peut également affecter la fertilité ? Ces substances nocives se retrouvent dans de nombreux produits, par exemple dans les cosmétiques, les textiles et le plastique. C'est pourquoi il est recommandé de laver ces produits avant de les utiliser.  Tu trouveras de plus amples informations sur l’impact des toxiques ici: 
<ul class="opsomming">
  <li>
    <a target="_blank" href="https://www.health.belgium.be/fr/perturbateurs-endocriniens">https://www.health.belgium.be/fr/perturbateurs-endocriniens</a>
  </li>
  <!--li>
    <a target="_blank" href="https://www.one.be/public/envie-dun-bebe/sante/visite-préconceptionnelle/">Visite préconceptionnelle</a>
  </li-->
  <li>
    <a target="_blank" href="https://www.one.be/public/envie-dun-bebe/consultation-peps/des-questions-sur-la-conception/">Des questions sur la conception</a>
  </li>
   <li>
    <a target="_blank" href="https://www.one.be/public/videodetail/youtube/air-de-familles-grossesse-la-visite-préconceptionnelle/">Vidéos informatives - Air de famille -: la visite préconceptionnelle</a>
  </li>
  
</ul>

                </p>
              </article>
          </div>
        </div>
      </section>


     

      <levensweg-footer class="footer" />
    </main>
  </div>
</template>

<script>
import Footer from "./../components/Footer";
import Header from "./../components/Header";

export default {
  components: {
    "levensweg-footer": Footer,
    "levensweg-header": Header,
  },
  mounted() {
    let section = this.$router.currentRoute.hash.replace("#", "");
    this.goto(section);
  },
  methods: {
    goto: function (refName) {
      var element = this.$refs[refName];

      if (element) {
        var top = element.offsetTop;
        window.scrollTo(0, top);
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style>
.lessspace {
  margin-top: 3rem;
}

.inhoudstabel {
  border-left: 1px solid var(--orange);
}

.opsomminginhoud {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 2rem;
}
.opsomminginhoud li {
  margin-bottom: 1rem;
}

.extrainfo a:link,
.extrainfo a:visited,
.extrainfo a:link:active,
.extrainfo a:visited:active {
  color: var(--blue);
}

.extrainfo .opsomming {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 3rem;
  list-style-type: disc;
}
.extrainfo .articlebody strong {
  font-weight: bold;
}

.extrainfo .infosection {
  /*margin-top:5rem;*/
  margin-bottom: 7rem;
}
.extrainfo .articletitle {
  -webkit-column-span: all;
  column-span: all;
  margin-top: 0.5rem;
}
.specialcols {
  -webkit-column-count: 1;
  -moz-column-count: 1;
  column-count: 1;
}

.footer {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}
.rightblok {
  display: flex;
  flex-direction: column;

  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left: -1.8rem;
  margin-right: -1.8rem;
}
.parentsaside {
  align-self: center;
}
.rightblock__line {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}

.rightblok:after {
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 100%;
  height: 368px;
  margin-top: -3rem;
}

.ivf {
  width: 342px;
  height: 324px;
}

.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
}
.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
}

.header--final {
  display: flex;
  flex-direction: column;
}

.infosection {
  display: flex;
  flex-direction: column;
}

.articleblocks {
  display: flex;
  flex-direction: column;
}

.infosection,
.testimonialsection {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
}

.sectiontitle {
  font-family: Montserrat;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2rem;
  color: var(--orange);
}

.sectionintro {
  font-family: "Playfair Display";
  font-size: 2rem;
  color: var(--titleslidecolor);
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.articletitle {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.articletitle.second {
  margin-top: 3rem;
}

.articlebody {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--articlebodycolor);
}
.articlebody.noheading {
  margin-top: 3rem;
}
.titleslide--final {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);

  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide--final {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 0 0 0;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}
.btn--final a {
  margin-left: 0;
}

.header--final {
  margin: 14.4rem 14.6% 0 14.6%;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .specialcols {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
  }
  .page {
    position: relative;
  }

  .babylyingcontainer {
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
    text-align: right;
  }
  .babylying {
    width: 80%;
    max-width: 449px;
    height: 80%;
    max-height: 374px;
  }
  .ivf {
    width: 308px;
    height: auto;
  }
  .infosection {
    flex-direction: row;
    align-items: flex-end;
  }
  .extrainfo .infosection::after {
    background: none;
  }
  .header--final {
    flex-direction: row-reverse;
    margin-left: 1.8rem;
    margin-right: 1.8rem;
    align-items: flex-end;
    margin-bottom: 8rem;
  }
  .header--final div {
    flex: 50%;
  }
  .sectionintro {
    width: 75%;
  }
  .extrainfo .sectionintro {
    width: 100%;
  }
  .rightblok:after {
    position: relative;

    margin-top: -100%;
  }
}

@media only screen and (min-width: 992px) {
  .infosection {
    align-items: flex-start;
  }

  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection.plan {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .articleblocks {
    flex-direction: row;
  }
  .sectionintro {
    width: 59.1rem;
  }

  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}

@media only screen and (min-width: 1200px) {
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .titleslide--final {
    font-size: 8rem;
    line-height: 1.06;
    width: 428px;
    max-width: 428px;
  }
  .babylyingcontainer {
    margin-right: 123px;
  }
  .header--final {
    margin-top: 81px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final {
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle {
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro {
    font-size: 3rem;
  }
  .articletitle {
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second {
    margin-top: 7.5rem;
  }
  .articlebody {
    font-size: 1.5rem;
  }
  .plan .articlebody {
    width: 40.9rem;
  }
  .page.final {
    height: auto;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .btn--final {
    margin-top: 4rem;
  }
}
</style>
